module.exports = __webpack_public_path__ + "static/media/cc9f94e1-e874-40aa-acfb-25b472524a41.67cc3b75.jpeg";